<!-- Created by Alex Poh. on 24/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<img class="img" [src]="imageSrc" alt="image" />
